module.exports = __webpack_public_path__ + "static/media/ฉลู.a4f852e5.png";